<template>
    <div>
        <dx-grid
            url="purimTransactions"
            :baseUrl="getDomain()"
            :columns="columns"
            :title="title"
            :summaryOptions="{
                enabled: true,
                columns: ['totalAmount', 'amount'],
            }"
            ref="grid"
            navigationPath="PurimStudentView"
            navigationField="studentID"
        ></dx-grid>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Transactions",
        columns: [
            {
                label: "Student ID",
                field: "studentID",
                visible: true,
                link: "PurimStudentView",
                template: "link-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "fullName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "NameE",
                field: "fullNameE",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father",
                field: "father",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered On",
                field: "enteredOn",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entrered By",
                field: "entreredBY",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Amount",
                field: "amount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Missing Amount",
                field: "missingAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Total Amount",
                field: "totalAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Payment Type",
                field: "paymentType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Ending",
                field: "cardNumLast4",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated By",
                field: "updatedBY",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated On",
                field: "updatedOn",
                visible: false,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "fname",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "laname",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "grade",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacher",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Notes",
                field: "note",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Confirmed",
                field: "confirmed",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {},
    methods: {
        getDomain() {
            return window.location.origin.startsWith("http://localhost:8080")
                ? "https://localhost:44338"
                : "https://purim-admin-portal.azurewebsites.net";
        },
    },
};
</script>
